














import Vue from "vue";
import { Prop,Component } from "vue-property-decorator";
@Component({
    components: {},
})
export default class DraggerImgDay extends Vue {
    // @Prop({
    //     default:false
    // })
    public disabledImg = false
    // 接受标题
    @Prop({
        default:'项目管理',
    })
    public whtitle:string;
    // 接受内容
    @Prop({
        default:''
    })
    public whcontent:string;
    // public mounted(){
    //     // 调用拖拽图片的方法
    // }
    mounted() {
        this.imgdrager()
    }

    isShow = false
    public imgdrager(){
         let that = this
            var box1 = document.getElementById("img1");
            box1.onmousedown = function (event) {
                console.log(1);
                /*再次点击时使得图标任然在那个位置，鼠标可以点击到图标上*/
                var ol = event.clientX - box1.offsetLeft;
                var ot = event.clientY - box1.offsetTop;
                /*鼠标点击*/
                document.onmousemove = function (event) {
                    that.disabledImg = true
                    console.log(1);
                    var left = event.clientX - ol;
                    var top = event.clientY - ot;
                    if (left < 0) {
                        left = 0;
                    }
                    else if (left > document.documentElement.clientWidth - box1.offsetWidth) {
                        left = document.documentElement.clientWidth - box1.offsetWidth;
                    }

                    if (top < 0) {
                        top = 0;
                    } else if (top > document.documentElement.clientHeight - box1.offsetHeight) {
                        top = document.documentElement.clientHeight - box1.offsetHeight;
                    }
                    box1.style.left = left+"px";/*赋值*/
                    box1.style.top = top+"px";

                }
                /*鼠标松开*/
                document.onmouseup = function (event) {
                    that.disabledImg = false
                    that.isShow = false
                    document.onmousemove = null;
                    document.onmouseup = null;
                }
                 return false
            }
    }
}
